{
    "Action.AddComment": "Tilføj kommentar",
    "Action.Close": "Luk",
    "Action.CloseAll": "Luk alle",
    "Action.ClosePanel": "Luk panel",
    "Action.CloseTab": "Luk fane",
    "Action.DeleteComment": "Slet kommentar",
    "Action.DeleteFilling": "Slet udfyldning",
    "Action.DuplicateFilling": "Dupliker udfyldning",
    "Action.EditComment": "Rediger kommentar",
    "Action.EditFilling": "Rediger udfyldning",
    "Action.ExpandTitle": "Udvid {{title}}",
    "Action.Generate": "Generer",
    "Action.GenerateChecklist": "Generer tjekliste",
    "Action.GenerateTemplates": "Generer skabeloner",
    "Action.GenerateToWord": "<small-1>Generer til<\/small-1> Word",
    "Action.NameFilling": "Navngiv udfyldning",
    "Action.NewFilling": "Ny udfyldning",
    "Action.OpenAll": "Åbn alle",
    "Action.OpenFilling": "Åbn udfyldning",
    "Action.OpenInDib": "Åbn i dib",
    "Action.OpenMenu": "Åbn menu",
    "Action.Reset": "Nulstil",
    "Action.ResetFields": "Nulstil felterne",
    "Action.Save": "Gem",
    "Action.SendToDflow": "<small-1>Send til<\/small-1> dflow",
    "Action.WriteAComment": "Skriv en kommentar",
    "Dashboard.pin": "Fastgør indhold",
    "Dashboard.pinToTop": "Fastgør til toppen",
    "Dashboard.removeFavorite.title": "Fjern fra favoritter",
    "Dashboard.removeFromTop": "Fjern fra toppen",
    "Dashboard.unpin": "Fjern fastgjort indhold",
    "Dashboard.unpin.confirm.title": "Skal det fastgjorte indhold fjernes?",
    "DocumentGenerator.Alternative": "Alternativ",
    "DocumentGenerator.ChooseAlternative": "Vælg alternativ",
    "DocumentGenerator.OptionalContent": "Vælg indhold",
    "Error.404Description": "Siden du spurgte efter findes ikke",
    "Error.FetchFillings": "Kunne ikke hente udfyldninger",
    "Error.NoFillingAccess": "Du har ikke adgang til denne udfyldning",
    "Error.NotFound": "Ikke fundet",
    "Error.SomethingWentWrong": "Noget gik galt",
    "Error.TryReloadingOrContactUs": "Prøv at genindlæse siden og <span-1><a-1>kontakt os<\/a-1> hvis problemet fortsætter.<\/span-1>",
    "Error.UnknownArtifact": "422 Indholdet kan ikke vises",
    "Info.ChooseADocumentToTheLeft": "Vælg et dokument til venstre",
    "Info.DataToDuplicate": "Data, der skal duplikeres",
    "Info.FillingWithoutName": "Udfyldning uden navn",
    "Info.GenerationNotAvailableForDemoUsers": "Generering er ikke tilgængelig for demobrugere.",
    "Info.IncludeInGeneration": "Inkluder i generering",
    "Info.MergeDocuments": "Saml valgte dokumenter til én pdf.",
    "Info.NoAvailableDocuments": "Ingen tilgængelige dokumenter",
    "Info.NoHits": "Ingen hits",
    "Info.RemoveFromGeneration": "Fjern fra generering",
    "Label.ConfirmAction": "Bekræft handling",
    "Label.DIBStandardTemplate": "DIB Standard stil",
    "Label.DuplicateName": "Navn på duplikat",
    "Label.MarkAllAsStatus": "Marker hele kategorien som {{status}}",
    "Label.ShowLess": "Vis mindre",
    "Label.ShowMore": "Vis mere",
    "Navigation.Lookup": "Opslag",
    "Phrase.AsEmailAttachment": "Som vedhæftning i email",
    "Phrase.AvailableOnDib": "Tilgængelig på dib",
    "Phrase.ChooseStyleTemplate": "Vælg stil",
    "Phrase.ChooseStyleTemplatePrompt": "Vælg en skabelon",
    "Phrase.DeliveredAs": "Leveres som",
    "Phrase.DownloadFile": "Download {{file}}",
    "Phrase.DuplicateOfTitle": "Duplikat af {{fillingTitle}}",
    "Phrase.FieldsInDocumentGenerator": "Felter i dokumentgenerator",
    "Phrase.InAWordDocument": "I et Word-dokument",
    "Phrase.IncludeInstructions": "Inkluder vejledning",
    "Phrase.LastEdited": "Sidst ændret",
    "Phrase.LoadingModal": "Indlæser...",
    "Phrase.NoAccess": "Ingen adgang",
    "Phrase.NoPreviousFillings": "Ingen tidligere udfyldninger",
    "Phrase.NoResultsOn": "Ingen resultater på",
    "Phrase.NoSearchResults": "Ingen hits",
    "Phrase.NoTemplatesChosen": "Ingen skabeloner er valgt",
    "Phrase.RemoveFilters": "Fjern filtre",
    "Phrase.SearchFilling": "Søg udfyldning",
    "Phrase.SendToDflow": "Send til dflow",
    "Phrase.ShowMore": "Vis mere",
    "Phrase.SorryYouDoNotHaveAccessToContent": "<strong-1>Beklager<\/strong-1>, du har ikke adgang til dette indhold.",
    "Prompt.WouldYouLikeToDeleteFilling": "Vil du slette udfyldningen <strong-1>{{fillingTitle}}<\/strong-1>?",
    "Status.Deviation": "Afvigelse",
    "Status.NA": "Ikke relevant",
    "Status.Ok": "OK",
    "Status.Todo": "Ubesvaret",
    "Status.WithComment": "Med kommentar",
    "Title.LabelOfContents": "Indholdsfortegnelse",
    "Title.RelatedContent": "Relateret",
    "Title.TemplatesWithCount": "Skabeloner ({{selectedDocsLength}})",
    "Type.AuditTemplate": "Revisorskabelon",
    "Type.ChartOfAccounts": "Kontoplan",
    "Type.ChecklistTemplates": "Tjekliste \/ Skabeloner",
    "Type.Decision": "Afgørelse",
    "Type.Directive": "Direktiv",
    "Type.Function": "Funktion",
    "Type.Handbook": "Håndbog",
    "Type.JuridiskVejledning": "Juridisk Vejledning",
    "Type.Law": "Lov",
    "Type.LegalCommentary": "Lovkommentar",
    "Type.Literature": "Faglitteratur",
    "Type.Nature": "Kunst",
    "Type.News": "Nyhed",
    "Type.PortalReference": "Oversigt",
    "Type.PortalSources": "Oversigt",
    "Type.PortalTools": "Oversigt",
    "Type.Praktika": "Praktika",
    "Type.PreparatoryWorks": "Forberedelse",
    "Type.Q&A": "Q&A",
    "Type.Regulation": "Forskrift",
    "Type.SkatteABC": "Skatte-ABC",
    "Type.Spreadsheet": "Regneark",
    "Type.Standard": "Standard",
    "Type.Statement": "Vejledning",
    "Type.TaxTreaty": "Skatteaftale",
    "Type.Template": "Skabelon",
    "Type.Topic": "Tema",
    "Type.Unknown": "Andet",
    "Warn.DataToDuplicateNotChosen": "Du har ikke valgt nogen data til duplikering",
    "Warning.AboutToMarkAllChecklistItems": "Du er ved at markere alle kontrolpunkter i denne kategori som <strong>{{status}}<\/strong>. Er du sikker?",
    "Widget.audit.process.title": "Revision - Skabeloner og Tjeklister",
    "Widget.content.description": "Indhold i dib, jeg har besøgt",
    "Widget.content.none": "Intet her.. Der vil dukke ting op, så snart du åbner indhold",
    "Widget.content.title": "Sidst besøgt",
    "Widget.favourites.title": "Mine favoritter",
    "Widget.fillings.description": "Skabeloner og tjeklister, jeg arbejder med",
    "Widget.fillings.none": "Ingen udfyldninger her... Begynd at udfylde tjeklister og templates, så dukker der ting op her.",
    "Widget.fillings.title": "Udfyldninger",
    "Widget.internal.portal.allAreas": "Alle områder",
    "Widget.internal.portal.content": "Indhold",
    "Widget.internal.portal.history": "Historik",
    "Widget.internal.portal.history.none": "Indhold du åbner vises her.",
    "Widget.internal.portal.myWork": "Mit arbejde",
    "Widget.internal.portal.myWork.none": "Gemte udfyldninger på vil vises her",
    "Widget.internal.portal.pinned": "Festet",
    "Widget.internal.portal.title": "Portaler",
    "Widget.internal.templates.title": "Seneste templates",
    "Widget.last.threads.none": "Dine samtaler og søgninger vil dukke op her",
    "Widget.last.threads.title": "Seneste tråde",
    "Widget.latest.news.title": "Nyheder",
    "Widget.threads.description": "Seneste chats\/tråde med KAI",
    "Widget.threads.none": "Intet her.. Når du begynder at søge\/chatte, dukker der ting op her",
    "Widget.threads.title": "Samtaler",
    "Word.Abort": "Afbryd",
    "Word.Checklist": "Tjekliste",
    "Word.Close": "Luk",
    "Word.Comments": "Kommentarer",
    "Word.Confirm": "Bekræft",
    "Word.Content": "Indhold",
    "Word.Created": "Oprettet",
    "Word.DocumentType": "Dokumenttype",
    "Word.Duplicate": "Dupliker",
    "Word.Edit": "Ændre",
    "Word.Email": "Email",
    "Word.Error": "Fejl",
    "Word.Filling": "Udfyldning",
    "Word.Footnote": "Fodnote",
    "Word.Generate": "Generer",
    "Word.Info": "info",
    "Word.Landscape": "Liggende",
    "Word.Less": "Mindre",
    "Word.More": "Mere",
    "Word.Name": "Navn",
    "Word.New": "Ny",
    "Word.Open": "Åben",
    "Word.PaperOrientation": "Papirretning",
    "Word.Portrait": "Stående",
    "Word.Remove": "Fjern",
    "Word.Sources": "Kilder",
    "Word.Status": "Status",
    "Word.StyleTemplate": "Stil",
    "Word.Template": "Skabelon",
    "Word.Templates": "Skabeloner",
    "Word.TheSearchText": "Søgeteksten",
    "Word.Untitled": "Uden titel",
    "Word.ZipFile": "ZIP-fil",
    "Word.create": "Opret",
    "action.seeLess": "Vis mindre",
    "action.seeMore": "Se mere",
    "alert.MergeConfirmBody": "Ved at krydse af for \"PDF-sammenlægning\" vil alle valgte dokumenter blive slået sammen til et PDF-dokument. De vil ikke kunne redigeres i Dflow.",
    "alert.MergeConfirmTitle": "PDF-sammenlægning",
    "animation.part.0": "Spørg",
    "animation.part.1": "KAI",
    "animation.part.2": "om",
    "animation.suggestion.1": "løn og HR",
    "animation.suggestion.2": "regnskab og moms",
    "animation.suggestion.3": "indhold i dib",
    "app.title": "KAI",
    "artifact.emailDraft.copied": "Kopieret!",
    "artifact.emailDraft.copyEmail": "Kopier e-mail",
    "artifact.emailDraft.empty": "Tomt e-mailudkast",
    "artifact.emailDraft.openInClient": "Åbn i e-mailklient",
    "artifact.emailDraft.subjectLabel": "Emne",
    "artifact.emailDraft.titleFallback": "E-mailudkast",
    "artifact.emailDraft.tooLongWarning": "E-mailen er for lang til at sende direkte via e-mailklienten. Brug kopieringsknappen til at kopiere indholdet og indsæt det manuelt.",
    "artifact.generic.titleFallback": "Artefakt",
    "artifact.pending.titleFallback": "Udkast",
    "artifact.searchResults.noResults": "Ingen resultater for \"{{query}}\"",
    "artifact.searchResults.resultsFor": "Resultater for \"{{query}}\"",
    "artifact.searchResults.showFewer": "Vis færre",
    "artifact.searchResults.showMore": "Vis {{count}} flere resultater",
    "artifact.searchResults.titleFallback": "Søgeresultater",
    "assistant.answerHeading": "Svar fra KAI",
    "brand.name": "dib",
    "callout.suggestplus.common.confirm": "Spørg igen med KAI+",
    "callout.suggestplus.common.text": "Ønsker du at foretage en dybere analyse med lidt mere ventetid?",
    "callout.suggestplus.common.title": "KAI kan ikke give et godt nok svar",
    "chat.ephemeral_search.nudge": "Er resultaterne ovenfor ikke relevante? Chat videre med mig nedenfor",
    "chat.experimentalEngineActive": "Eksperimentel motor",
    "chat.limit.body": "For at sikre at KAI giver dig præcise svar, afsluttes samtaler efter 50 beskeder.",
    "chat.limit.button": "Start ny chat",
    "chat.limit.heading": "Grænsen er nået",
    "chat.multi_stream.capacity_message": "Tre samtaler er allerede i gang. Vent venligst, til en er afsluttet.",
    "chat.multi_stream.capacity_title": "For mange aktive samtaler",
    "common.askQuestion": "Stil et spørgsmål",
    "common.cancel": "Annuller",
    "common.closeSidebar": "Luk sidefelt",
    "common.collapseSidebar": "Luk sidepanel",
    "common.copied": "Kopieret",
    "common.copy": "Kopier",
    "common.defaultThreadTitle": "Ny tråd",
    "common.delete": "Slet",
    "common.disclaimer": "Svar fra KAI kan indeholde fejl",
    "common.editMessage": "Rediger besked",
    "common.expandSidebar": "Åbn sidepanel",
    "common.getStarted": "Stil et spørgsmål for at komme i gang!",
    "common.goBack": "Gå tilbage",
    "common.loadingTranslations": "Indlæser oversættelser...",
    "common.malerAndChecklists": "Skabeloner og tjeklister",
    "common.newChat": "Ny chat",
    "common.noResults": "Ingen søgeresultater",
    "common.openSidebar": "Åbn sidefelt",
    "common.otherContentFromDIB": "Andet indhold fra dib",
    "common.recentChats": "Nylige tråde",
    "common.recentSearches": "Sidst besøgt i dib",
    "common.recentThreads": "Seneste tråde",
    "common.regenerate": "Gendan svar",
    "common.rename": "Ændr navn",
    "common.save": "Gem",
    "common.search": "Søg",
    "common.searchBox": "Spørg <strong>KAI<\/strong> eller søg efter indhold",
    "common.seeAll": "Se alle",
    "common.send": "Send",
    "common.share": "Del",
    "common.showAll": "Vis alle ({{count}})",
    "common.showLess": "Vis færre",
    "common.suggestions": "Forslag",
    "common.thinking": "Tænker... AI-svar er ikke altid fejlfri. Husk at tjekke kilderne fra dib!",
    "common.tryAgain": "Prøv igen",
    "common.visibleForAdmins": "Synlig for admins",
    "common.yesterday": "I går",
    "content.comment": "Kommentar",
    "content.lawRulesMirror": "Lov\/forskriftsspejl",
    "content.relatedSources": "Relaterede kilder",
    "content.tags": "Stikord",
    "content.translation": "Oversættelse",
    "contextSidebar.BetaDisclaimer": "Sidepanelet er under udvikling. Vi arbejder løbende på at hente gode søgeresultater fra dib.",
    "contextSidebar.OtherHeading": "Andet indhold fra dib",
    "contextSidebar.ThreadExplanation": "Chatbeskrivelse (AI-genereret)",
    "contextSidebar.ToolsHeading": "Værktøjer fra dib",
    "contextSidebar.closeContextSidebar": "Luk kontekst-sidefelt",
    "contextSidebar.error": "Fejl ved indlæsning af indhold",
    "contextSidebar.noRelatedContent": "Der blev ikke fundet nogen relaterede emner eller kilder i dib",
    "contextSidebar.noRelatedTemplates": "Fandt ingen relaterede templates eller tjeklister i dib",
    "contextSidebar.openContextSidebar": "Åbn sidepanelet",
    "date.last30Days": "De sidste 30 dage",
    "date.lastWeek": "Sidste uge",
    "date.previously": "Tidligere",
    "date.today": "I dag",
    "debug.addSuggestion": "Tilføj forslag",
    "error.contentFilter.body": "Spørgsmålet blev blokeret af indholdsfiltreret. Rediger din besked ovenfor og prøv med andre ord.",
    "error.contentFilter.title": "Indholdssikring",
    "error.contextLength.body": "Chatten har vokset sig for lang.",
    "error.contextLength.title": "Chat for lang",
    "error.filteredContent.body": "Svaret blev filtreret fra på grund af, at dit spørgsmål udløste vores indholdspolitik. Rediger venligst dit spørgsmål og prøv igen.",
    "error.interrupted.body": "Det forrige svar blev ikke fuldført. Prøv at stille spørgsmålet igen for at få et nyt svar.",
    "error.interrupted.title": "Svaret blev afbrudt",
    "error.rateLimit.body": "Du har nået grænsen for antallet af forespørgsler. Vent et par minutter og prøv igen. Hvis problemet fortsætter, kontakt brugersupport.",
    "error.rateLimit.title": "For mange forespørgsler",
    "error.unknown.body": "Der er opstået en ukendt fejl under generering af svaret.",
    "error.unknown.title": "Ukendt fejl",
    "file.download": "Download {{file}}",
    "file.downloadNotForDemo": "Fil download er ikke tilgængelig for demobrugere",
    "forbidden.description": "Beklager, du har ikke adgang til at bruge denne applikation. Kontakt os venligst, hvis du mener, dette er en fejl.",
    "forbidden.title": "Adgang nægtet",
    "input.placeholder.splash": "Hvad har du brug for hjælp til?",
    "input.placeholder.thread": "Stil et opfølgningsspørgsmål",
    "menu.item.desc.deep": "Analyserer og ræsonnerer mere",
    "menu.item.desc.fast": "KAI giver dig enkle, hurtige svar",
    "menu.item.disabledtooltip.deep": "Denne funktionalitet er ikke tilgængelig for dig.",
    "menu.item.time.deep": "~20 sek",
    "menu.item.time.fast": "~10 sek",
    "menu.item.title.deep": "KAI+",
    "menu.item.title.fast": "Hurtige svar",
    "name.Dflow": "Dflow",
    "prompt.heading.welcome": "Hvad kan jeg hjælpe dig med?",
    "rag.state.answering": "Svarer",
    "rag.state.finished": "Tænkte i {n} sekunder",
    "rag.state.finishedNoTime": "Sammendrag",
    "rag.state.idle": "Tænker",
    "rag.state.reading": "Læser indhold",
    "rag.state.searching": "Søger i kilderne",
    "rag.state.summarizing": "Oplister relevante kilder",
    "rating.addRating": "Giv feedback",
    "rating.comment.placeholder": "Kommentar",
    "rating.editRating": "Ændr feedback",
    "rating.modal.button": "Indsend feedback",
    "rating.modal.cancel": "Spring over",
    "rating.modal.category.0": "Svaret indeholder fejl",
    "rating.modal.category.1": "KAI fulgte ikke mine instruktioner",
    "rating.modal.category.2": "Jeg var ikke tilfreds med svarets struktur",
    "rating.modal.category.3": "KAI anvender forkerte kilder fra dib",
    "rating.modal.category.4": "Andet feedback",
    "rating.modal.category.5": "Forældet information",
    "rating.modal.description": "Vælg en kategori nedenfor. Tak fordi du hjælper os med at forbedre KAI.",
    "rating.modal.elaborate": "Uddyb gerne...",
    "rating.modal.title": "Tak for din feedback",
    "rating.response.isHelpful": "Vurder svar som nyttigt",
    "rating.response.isNotHelpful": "Vurder svar som ikke nyttigt",
    "rating.submit": "Send",
    "rating.text": "Efterlad en kommentar",
    "references.consideredSources.title": "Derudover søgte KAI gennem disse kilder:",
    "references.consideredSources.tooltip": "Vis andre overvejede kilder",
    "references.relatedTools.title": "Foreslåede værktøjer",
    "references.title": "Svaret er baseret på disse kilder fra DIB",
    "reflections.button.text": "Refleksioner",
    "reflections.button.text.loading": "Analyserer spørgsmålet",
    "rename.modal.label": "Nyt navn",
    "rename.modal.title": "Omdøb tråd",
    "sessionExpired.description": "Din session blev afsluttet, og vi kunne ikke genstarte den automatisk. Prøv at logge ind igen. Hvis dette fortsætter, bedes du kontakte support.",
    "sessionExpired.signOut": "Log ud",
    "sessionExpired.title": "Sessionen er udløbet",
    "settings.accountDetails": "Kontodetaljer",
    "settings.chatEngine": "Chat-motor",
    "settings.field.chatEngine.experimental": "Eksperimentel",
    "settings.field.chatEngine.standard": "Standard",
    "settings.field.company.description": "Dit firma",
    "settings.field.company.title": "Virksomhed",
    "settings.field.email.description": "Din e-mail",
    "settings.field.email.title": "E-mail",
    "settings.field.name.description": "Dit navn",
    "settings.field.name.title": "Navn",
    "settings.field.response.deep": "KAI+",
    "settings.field.response.fast": "Hurtig",
    "settings.field.sidebarPosition.left": "Venstre",
    "settings.field.sidebarPosition.right": "Højre",
    "settings.language": "Sprog",
    "settings.logout": "Log ud",
    "settings.preferences": "Indstillinger",
    "settings.responseType": "Forudvalgt svartype",
    "settings.showInternalFeatures": "Vis admin funktionalitet",
    "settings.sidebarPosition": "Kontekst-sidefelt position",
    "settings.title": "Indstillinger",
    "suggestionQuestion.1": "Hvordan beskattes en engangsbonus, jeg har fået som tak for en særlig indsats?",
    "suggestionQuestion.2": "Mister jeg min ferie, hvis jeg ikke når at holde 4 uger?",
    "table.close": "Luk",
    "table.expand": "Udvid",
    "table.fullscreenTitle": "Luk fuldskærm ved at trykke på krydset helt til højre, eller tryk på <span>Esc<\/span> tasten.",
    "table.openFullscreen": "Åbn tabel i fuld skærm",
    "thread.postsearch.filters.button": "Filter",
    "thread.postsearch.filters.otherSources": "Andre kilder",
    "thread.postsearch.filters.tools": "Værktøjer",
    "thread.postsearch.note": "<strong>Matcher søgningen ikke dine forventninger?<strong><\\br> Vi arbejder konstant på at gøre DIB-resultaterne mere relevante",
    "thread.postsearch.resultsFor": "Søgeresultater for",
    "thread.tabs.answer": "Svar fra KAI",
    "thread.tabs.answerReady": "Svar klar",
    "thread.tabs.search": "Resultater i DIB",
    "topicSidebar.OtherHeading": "Andet innhold",
    "topicSidebar.ToolsHeading": "Værktøjer",
    "userinput.button.text.deep": "KAI+",
    "userinput.button.text.fast": "Hurtig",
    "userinput.placeholder": "Spørg KAI",
    "word.Expand": "Udvid"
}